// extracted by mini-css-extract-plugin
export default {"ipad_layout":"index_ipad_layout_Xc-io","layout":"index_layout_zJZkR","request_no":"index_request_no_f2bIv"};